import { dispatchLoad, fetchDispatchQueue } from './operatorDispatchThunks';
import { DISPATCH_OUTCOME } from './operatorDispatchUtils';
import { OPERATOR_FLOW } from '../operator/operatorConstants';
import { isTaskOnScreen } from '../operator/operatorTaskScope';

/** Whether a dispatch took some order out of the queue: one left now, or had left already. */
const tookOrdersOut = (action) =>
  (action.payload?.results || []).some((result) => result.outcome !== DISPATCH_OUTCOME.FAILED);

/**
 * The station's reactions. Once a dispatch took orders out, the queue on
 * screen is asked again, of the courier it shows. Off screen nothing is
 * asked: the station asks for its queue when it opens.
 *
 * @param {Function} startListening
 */
export const registerOperatorDispatchListeners = (startListening) => {
  startListening({
    predicate: (action, state) =>
      dispatchLoad.fulfilled.match(action) &&
      tookOrdersOut(action) &&
      isTaskOnScreen(state, OPERATOR_FLOW.DISPATCH, null),
    effect: (_, { dispatch, getState }) => {
      dispatch(fetchDispatchQueue({ courier: getState().operatorDispatch.queue.courier, page: 1 }));
    },
  });
};
